// Веб-вклад модуля `flashcards` — карточки + SRS.
//
// Две плитки воркспейса из одного модуля: «ещё карточки» (шаг ②) и «карточки по
// пробелу» (шаг ③). Разные подписи и разные шаги, но один вид комплекта: по
// пробелу комплект пересобирается с `adaptiveContext` — это решает генератор,
// а не плитка.

import { IconCards } from "@tabler/icons-react";
import {
	SECTION_CATEGORY,
	SECTION_ICONS,
	SECTION_TINT,
} from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const flashcardsWebManifest = {
	id: "flashcards",
	icon: SECTION_ICONS.flashcards,
	labelKey: "nav.flashcards",
	category: SECTION_CATEGORY.flashcards,
	routes: ["/flashcards"],
	overlayShellPrefixes: ["/flashcards/study"],

	// Баннер объясняет МЕХАНИКУ повторов: сама по себе колода карточек ничего
	// не обещает, а расписание показов — обещает, и его не видно из названия.
	// Заодно отделяет карточки от тестов (разовая проверка ↔ повторение).
	intro: {
		titleKey: "flashcards:intro.title",
		bodyKey: "flashcards:intro.body",
		bulletKeys: [
			"flashcards:intro.bullets.0",
			"flashcards:intro.bullets.1",
			"flashcards:intro.bullets.2",
		],
	},

	nav: [
		{
			key: "flashcards",
			to: "/flashcards",
			icon: SECTION_ICONS.flashcards,
			labelKey: "nav.flashcards",
			order: 40,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM flashcard_sets WHERE user_id = ? AND deleted_at IS NULL",
			},
		},
	],

	launch: [
		{
			key: "flashcards",
			icon: SECTION_ICONS.flashcards,
			tint: SECTION_TINT.flashcards,
			titleKey: "launcher.flashcards",
			hintKey: "launcher.flashcardsHint",
			to: "/flashcards",
			order: 120,
		},
	],

	workspaceTools: [
		{
			key: "moreCards",
			channel: "practice",
			icon: IconCards,
			steps: { 2: 10 },
			kitKind: "flashcards",
		},
		{
			key: "gapCards",
			channel: "practice",
			icon: IconCards,
			steps: { 3: 30 },
			kitKind: "flashcards",
		},
	],
} satisfies WebModuleManifest;
